// Drag and drop files to upload
export const dropToUploadFile = () => {
  const endDragEvents = ['dragend', 'dragleave']
  const uploadFileInput = document.querySelectorAll('.js-drop__input')
  const ctaProfile = document.querySelector('.js-save-profile')
  const MAX_SIZE = 4 * 1024 * 1024;
  const DEFAULT_IMG = 'https://assets.adsttc.com/hayden/main-image-placeholder.jpg'
  const DROP_AREA_UI_ERROR = 'logo-image__main-image--error'
  const INFO_ERROR = 'logo-image__main-image-info-error'

  uploadFileInput.forEach( input => {
    const dropArea = input.closest('.js-drop__area')
    
    const handleInfo = () => {
      const infoCopy = dropArea.querySelector('.js-drop__info')
      const copy = infoCopy.querySelector('.js-drop__copy')
      const changeCopy = infoCopy.getAttribute('data-change')

      infoCopy.classList.add('hide-it')
      copy && (copy.innerHTML = changeCopy)
    }

    const validateImageSize =  (input, area, cta) => { 

      if (isImgRightSize(input)) {
        handleInfo()
        readURL(input)
        showImgUIValidations(area, cta) 
      } else {
        showImgUIErrorValidations(input, area, cta)
      }
    }

    const isImgRightSize = input => {
      return  input?.files.length && input.files[0].size < MAX_SIZE
    }

    const showImgUIValidations = (area, cta) => {
      if (area && area.classList.contains(DROP_AREA_UI_ERROR)) {
        area.classList.remove(DROP_AREA_UI_ERROR)
        area.querySelector(`.${INFO_ERROR}`)?.remove()
        
        if (cta) {
          cta.removeAttribute('disabled')
          cta.setAttribute('type', 'submit')
        }
      }
    }

    const showImgUIErrorValidations = (input, area, cta) => {
      if (!area) return console.error("dropArea is undefined")
      const image = area.querySelector('.js-image-to-update')
      const infoCopy = input.parentNode.querySelector('.js-drop__info')
      const lastError = area.querySelector(`.${INFO_ERROR}`)
      
      image && image.getAttribute('src') !== "" && (image.setAttribute('src', DEFAULT_IMG))
      infoCopy.classList.contains('hide-it') && infoCopy.classList.remove('hide-it')

      if (!lastError) {
        const copyArea = area.querySelector('.js-drop__info')
        const error = document.createElement('p')
        error.classList.add(INFO_ERROR)
        error.textContent = area.getAttribute('data-size-error')
        area.classList.add(DROP_AREA_UI_ERROR)
        copyArea && copyArea.append(error)
      }
      
      if (cta) {
        cta.setAttribute('disabled', true)
        cta.setAttribute('type', 'button')
      }
    }


    dropArea.addEventListener( 'dragover', e => {
      e.preventDefault()
      dropArea.classList.add('dragover')
    })

    // Leave or end the dragover
    endDragEvents.forEach( typeEvent => {
      dropArea.addEventListener( typeEvent, () => {
        dropArea.classList.remove('dragover')
      })
    })

    // Drop item in the area
    dropArea.addEventListener('drop', e => {
      e.preventDefault()
      
      // Preview Image uploaded droping the image
      if (e.dataTransfer.files.length) {
        input.files = e.dataTransfer.files
        dropArea.classList.remove('dragover')
        validateImageSize(input, dropArea, ctaProfile)
      }
    })

    // Preview Image uploaded using browser file
    input.addEventListener('change', () => {
      validateImageSize(input, dropArea, ctaProfile)
    })

    // Function to preview image uploaded
    const readURL = input => {
      const reader = new FileReader()
      const image = dropArea.querySelector('.js-image-to-update')
      reader.onload = e => image.setAttribute('src', e.target.result)
      reader.readAsDataURL(input.files[0])
      if (image.classList.contains('kth-avatar-input__img-fallback')) {
        image.classList.remove('kth-avatar-input__img-fallback')
      }
    }
  })
}